import { useLocalizedErrorMessage } from '@bv/composables';

import type { ErrorObject } from '@vuelidate/core';

export const getErrorMessages = (errorMessages?: ErrorObject | ErrorObject[] | string | string[]): string[] => {
  // Single string
  if (typeof errorMessages === 'string') {
    return [errorMessages];
  }

  // Array of strings
  if (Array.isArray(errorMessages) && errorMessages.every((e) => typeof e === 'string')) {
    return errorMessages as string[];
  }

  // Single record
  if (!Array.isArray(errorMessages) && typeof errorMessages === 'object' && errorMessages !== null) {
    return [useLocalizedErrorMessage(errorMessages as any).localizeErrorMessage.value];
  }

  // Array of records
  if (Array.isArray(errorMessages) && errorMessages.every((e) => typeof e === 'object' && e !== null)) {
    return errorMessages.map((e) => useLocalizedErrorMessage(e as ErrorObject).localizeErrorMessage.value);
  }

  // default case
  return [];
};
